export default __webpack_public_path__ + "static/media/money-bag.43ef51d7.png";